export const MINT_INIT = 'MINT_INIT';
export const DISPLAY_SLOT_LOADED = 'DISPLAY_SLOT_LOADED';
export const SEND_LOTAME_INTERESTS = 'SEND_LOTAME_INTERESTS';

export function mintInit() {
  return {
    type: MINT_INIT,
  };
}

export function displaySlotLoaded(elementId) {
  return (dispatch) => {
    dispatch({
      type: DISPLAY_SLOT_LOADED,
      elementId,
    });
    // clear display slot store state immediately
    return dispatch({
      type: DISPLAY_SLOT_LOADED,
      elementId: '',
    });
  };
}

export function sendLotameInterests(lotameInterests) {
  return {
    type: SEND_LOTAME_INTERESTS,
    interests: lotameInterests,
  };
}
